import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Zoom from 'react-medium-image-zoom'



function Item() {
    const [item, setItem] = useState({});
    let modal0;

    function click_buy0(e) {
        e.preventDefault();
        modal0 = new window.bootstrap.Modal(document.getElementById('buy_now'));
        modal0.show();
    }

    function click_buy(e) {
        e.preventDefault();
        window.wait().then(async ()=>{
            if (!window.app.tonConnectUI.account?.address) {
                alert('Connect wallet');
                return;
            }
            let modal1 = new window.bootstrap.Modal(document.getElementById('buy_1'));
            let modal2 = new window.bootstrap.Modal(document.getElementById('buy_2'));
            let modal3 = new window.bootstrap.Modal(document.getElementById('buy_3'));
            window.cb = (a) => {
                modal1.hide();
                modal2.show();
            };
            modal0.hide();
            modal1.show();
            await window.app.submit();
            modal2.hide();
            modal3.show();
        });
    }

    useEffect(() => {
        window.wait().then(async ()=>{
            const nft_address = new URL(window.location.href).searchParams.get('a');
            if (nft_address) {
                const items = await fetch(`${window.app.HOST}/nft?owner_address=`).then(res=>res.json());
                const nft = items.find(x=>x.address==nft_address);
                console.log('nft', nft);
                // document.querySelectorAll('.btn-main.btn-lg').forEach($x=>$x.textContent = nft.status=='sold' ? 'SOLD' : nft.price ? `${nft.price} TON` : '-');
                document.querySelectorAll('.btn-main.btn-lg').forEach($x => {
                    if (nft.status === 'sold') {
                        const soldSpan = document.createElement('h2');
                        soldSpan.textContent = 'SOLD';
                        $x.parentNode.replaceChild(soldSpan, $x);
                    } else {
                        $x.textContent = 'BUY';
                    }
                });
                document.querySelector('.nft-item-price span').textContent = `${nft.price} TON`;
                document.querySelector('.nft-name').textContent = nft.name;
                document.querySelector('.nft-description').textContent = nft.description;
                document.querySelector('.profile_wallet').textContent = window.app.Address.parse(nft.address).toString();
                window.nft = nft;
                document.querySelector('.profile_wallet').href = `https://testnet.tonviewer.com/${nft.address}`;
                document.querySelector('#token_id').textContent = nft.id;
                document.querySelector('#royalty_fee').textContent = nft.fee;
                document.querySelector('#owner').textContent = nft.owner_address;

                document.querySelector('#created').textContent = new Date(nft.created).toLocaleDateString("it-IT", {});
                document.querySelector('#image').src = nft.image.replace("ipfs://", "https://ipfs.io/ipfs/");
                const img = document.querySelector('#image');
                document.querySelector('#dimensions').textContent = `${img.naturalWidth}x${img.naturalHeight}`;
                setItem(nft);
            }
            // Wait a moment for the plugin to apply its styles, then fix them.
            setTimeout(() => {
                const tab1 = document.querySelector('.tab-1');
                const tab2 = document.querySelector('.tab-2');
                const tab3 = document.querySelector('.tab-3');

                if (tab1) {
                tab1.style.display = tab1.classList.contains('active') ? 'block' : 'none';
                }
                if (tab2) {
                tab2.style.display = tab2.classList.contains('active') ? 'block' : 'none';
                }
                if (tab3) {
                tab3.style.display = tab3.classList.contains('active') ? 'block' : 'none';
                }
            }, 300); 
        });
    }, []);

    
    return (
        <div id="wrapper" className="switch-scheme">
            {/* Header component */}
            <Header />

            <div className="no-top" id="content">
                <div id="top"></div>
                <section id="nft-item-details" aria-label="section" className="sm-mt-0">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-md-6 text-center" style={{ marginTop: '150px',marginBottom: '150px' }}>

                                <Zoom>
                                    <div className="nft-image-wrapper">
                                        <img id="image" src="images/items/big-6.jpg" className="image-autosize img-fluid img-rounded mb-sm-30 zoomable" alt="" />
                                    </div>
                                </Zoom>


                            </div>

                            <div className="col-md-6" style={{ marginTop: '150px' }}>
                                <div className="item_info">
                                  
                                    <h2 className="nft-name mb-0">Diminishable #108</h2>
                                    <div class="mb20">created by <a class="defaultLink shortened-address" href="/profile">{item.creator_address}</a></div>
                                    <h6 className='mb-1'>Description</h6>
                                    <p className="nft-description">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                                        eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                                    </p>
                                    {/* <h6>Artist social media</h6>
                                    <div className="de-flex-col">
                                        <div className="social-icons">
                                            <a href="#"><i className="fa fa-facebook fa-lg"></i></a>
                                            <a href="#"><i className="fa fa-twitter fa-lg"></i></a>
                                        </div>
                                    </div> */}
                                    <div className="spacer-10"></div>

                                    <div className="de_tab tab_simple">
                                        <ul className="de_nav">
                                            <li className='active'><span>Buy</span></li>
                                            <li><span>Details</span></li>
                                            <li><span>Activities</span></li>
                                        </ul>
                                        <div className="de_tab_content">
                                            <div className="tab-1 active">

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '20px', // Space between the two divs
                                                        alignItems: 'flex-start', // Align items at the top
                                                        flexWrap: 'wrap', // Ensures responsiveness if there's not enough space
                                                    }}
                                                >
                                                    <div style={{ flex: 1, maxWidth: '70%' }}>
                                                        <h5>Price</h5>
                                                        <div className="nft-item-price mb-3">
                                                            <img src="https://ton.org/download/ton_symbol.svg" alt="" />
                                                            <span>0.059 TON</span> ($253.67)
                                                        </div>
                                                        <h6><span className="edition">Edition</span> Unique</h6>
                                                        <a
                                                            href="#"
                                                            className="btn-main btn-lg"
                                                            onClick={click_buy0}
                                                        >
                                                            Buy Now
                                                        </a>
                                                    </div>
                                                    <div style={{ flex: 1, maxWidth: '22%' }}>
                                                        <h1 style={{ fontSize: '16px' }} className='mb0'>View Artwork in AR or in our VR Gallery</h1>
                                                        <a href="https://create.overlyapp.com/webar/c04fd75806962e1f21afd11abd8f3d8203cfdc35"><img
                                                            style={{ maxWidth: '100%' }}
                                                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/220px-QR_code_for_mobile_English_Wikipedia.svg.png"
                                                            alt="Augmented Reality"
                                                        /></a>
                                                        <a style={{color:'#000'}} href="https://instant.gallery/g/GALLERY3-GALLERY3">TEST VR</a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="tab-2">
                                                <div className="d-flex flex-row">
                                                    <div className="mr40">
                                                        <div className="item_author">
                                                            <div className="author_list_pp">
                                                                <a href="/profile">
                                                                    <img className="lazy" src="/images/author/author-11.jpg" alt="" />
                                                                    <i className="fa fa-check"></i>
                                                                </a>
                                                            </div>
                                                            <div className="author_list_info">
                                                                <h6>Artist</h6>
                                                                <a href="/profile" className='shortened-address'>{item.creator_address}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mr40">
                                                        <div className="item_author">
                                                            <div className="author_list_pp">
                                                                <a href="/collection">
                                                                    <img className="lazy" src="images/collections/coll-thumbnail-3.jpg" alt="" />
                                                                </a>
                                                            </div>
                                                            <div className="author_list_info">
                                                                <h6>Collection</h6>
                                                                <a href="/collection">Diminishable</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="item_author">
                                                            <div className="author_list_pp">
                                                                <a href="/gallery">
                                                                    <img className="lazy" src="images/collections/coll-thumbnail-3.jpg" alt="" />
                                                                </a>
                                                            </div>
                                                            <div className="author_list_info">
                                                                <h6>Gallery</h6>
                                                                <a href="/gallery">Diminishable</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="spacer-40" style={{ borderBottom: '1px solid rgba(200, 200, 200, 0.5)' }}></div>
                                                
                                                <div className="row gx-2" style={{ marginTop: '10px' }}>
                                                    <div className="p_list">
                                                         <div class="p_list_info" >
                                                        Owner
                                                        <span>
                                                        <b><a href="#" id='owner'></a></b></span>
                                                        </div>
                                                        <div className="p_list_info" >
                                                            NFT Contract address
                                                            <span>
                                                                <b>
                                                                    <a className="profile_wallet" href="https://tonviewer.com/EQComBp_vS5vSmEPkJ5gunx6UUMnvAX9gYa1ECkmCQuj2kuu">
                                                                        DdzFFzCqrhshMSxb9oW3mRo4MJrQkusV3fGFSTwaiu4wPBqMryA9DYVJCkW9n7twCffG5f5wX2sSkoDXGiZB1HPa7K7f865Kk4LqnrME
                                                                    </a>
                                                                </b>
                                                            </span>
                                                        </div>
                                                        <div className="p_list_info" >
                                                            Sale Contract
                                                            <span>
                                                                <b>
                                                                    <a className="profile_wallet" href="https://tonviewer.com/EQComBp_vS5vSmEPkJ5gunx6UUMnvAX9gYa1ECkmCQuj2kuu">
                                                                        DdzFFzCqrhshMSxb9oW3mRo4MJrQkusV3fGFSTwaiu4wPBqMryA9DYVJCkW9n7twCffG5f5wX2sSkoDXGiZB1HPa7K7f865Kk4LqnrME
                                                                    </a>
                                                                </b>
                                                            </span>
                                                        </div>
                                                        <div class="p_list_info" >
                                                            Token ID
                                                            <span><b id="token_id">318</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Marketplace Fee
                                                            <span><b>5%</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Gallery Fee
                                                            <span><b>5%</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Royalty Fee
                                                            <span><b id="royalty_fee">0%</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Metadata
                                                            <span><b>IPFS</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Medium
                                                            <span><b>Image(JPEG)</b></span>
                                                        </div>
                                                        {/* <div class="p_list_info">
                                                            Type
                                                            <span><b>Drawing</b></span>
                                                        </div> */}
                                                        <div class="p_list_info">
                                                            File size
                                                            <span><b>31.5 MB</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Dimensiones
                                                            <span><b id="dimensions">4000x4000px</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Blockchain
                                                            <span><b>TON</b></span>
                                                        </div>
                                                        {/* <div class="p_list_info">
                                                            Token standard
                                                            <span><b>BEP-624</b></span>
                                                        </div> */}
                                                        <div class="p_list_info">
                                                            Created with
                                                            <span><b>Gallery3</b></span>
                                                        </div>
                                                        <div class="p_list_info">
                                                            Released
                                                            <span><b id="created">Aug 14, 2024</b></span>
                                                        </div>

                                                    </div>
                                                    <div className="spacer-30"></div>
                                                </div>
                                            </div>
                                            <div className="tab-3">
                                                <h6>No activities yet.</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="spacer-10"></div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        <div class="modal fade" id="buy_now" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered de-modal">
            <div class="modal-content">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              <div class="modal-body">
                <div class="p-3 form-border">
                    <h3>Buy NFT</h3>
                    You are about to purchase a <b>{item.name}</b> from <b>Monica</b>
                    <div class="spacer-single"></div>
                    {/* <h6>Enter quantity. <span class="id-color-2">10 available</span></h6>
                    <input type="text" name="buy_now_qty" id="buy_now_qty" class="form-control" value="1" /> */}
                     
                    <div class="de-flex">
                        <div>NFT Price</div>
                        <div><b>{item.price} TON</b></div>
                    </div>
                    <div class="de-flex">
                        <div>Network fee <span style={{fontSize:'12px'}}>(the rest will be returned to your wallet)</span> </div>
                        <div>max<b>0.1 TON</b></div>
                    </div>
                    <div class="de-flex">
                        <div>Service fee 5%</div>
                        <div><b>{(parseFloat(item.price) * 0.05).toLocaleString(void 0, {minimumFractionDigits: 2, maximumFractionDigits: 6})} TON</b></div>
                    </div>
                    {/* <div class="de-flex">
                        <div>You will pay</div>
                        <div><b>0.013325 TON</b></div>
                    </div> */}
                    <div class="spacer-single"></div>
                    <a onClick={click_buy} href="wallet.html" target="_blank" class="btn-main btn-fullwidth">Buy for {(0.1 + parseFloat(item.price) * (1 + parseFloat(item.fee)/100)).toLocaleString(void 0, {minimumFractionDigits: 2, maximumFractionDigits: 6})} TON</a>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="modal fade" id="buy_1" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered de-modal">
                <div class="modal-content">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-body">
                        <div class="p-3 form-border">
                            <h3>Almost ready </h3>
                            <b>Transaction</b>
                            <div class="spacer-single"></div>
                            <h6>Go to the wallet app and confirm the transaction.</h6>


                            <div class="spacer-single"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="buy_2" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered de-modal">
                <div class="modal-content">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-body">
                        <div class="p-3 form-border">
                        <h3>Almost ready</h3>
                        <p>Payment received</p>
                        <b>Checking paymentet</b>
                            <div class="spacer-single"></div>
                            <h6>We are checking the payment. It may take some time.</h6>


                            <div class="spacer-single"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="buy_3" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered de-modal">
                <div class="modal-content">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-body">
                        <div class="p-3 form-border">
                        <h3>Nice! You have purchesed the NFT.</h3>
                        <div class="spacer-single"></div>
                        <h6>You can check your wallet and view your new NFT. </h6>


                            <div class="spacer-single"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Item;